import React, { useEffect } from 'react';
import { TwitterTimelineEmbed } from 'react-twitter-embed';
import './SMFeeds.css';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles({
  section: {
    paddingTop: '48px',
    paddingBottom: '16px',
    ['@media (max-width:768px)']: {
      paddingTop: '24px',
      paddingBottom: '8px',
    },
  },
  row: {
    display: 'flex',
    flexwrap: 'wrap',
    marginRight: '0px',
    marginLeft: '0px',
    padding: '0px',
    justifyContent: 'center',
    ['@media (max-width:768px)']: {
      paddingRight: '20px',
      paddingLeft: '20px',
    },
  },
});

function SMFeeds() {
  const classes = useStyles();
  // Adding Facebook Timeline(for responsive width) - stick the page in https://developers.facebook.com/docs/plugins/page-plugin/ to get the iFrame code
  useEffect(() => {
    let width =
      document.getElementById('twitterTimeline').firstChild.clientWidth;
    //     document.getElementById("facebookTimeline").innerHTML = `<iframe
    //     src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FSigBowls&tabs=timeline&width=${width}&height=400&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId=298222915194974"
    //     height="400"
    //     width=${width}
    //     style={{ border: "none", overflow: "hidden", width: "100%" }}
    //     scrolling="no"
    //     frameborder="0"
    //     data-adapt-container-width="true"
    //     allowFullScreen="true"
    //     allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
    //   ></iframe>
    // `;
  });
  const { t } = useTranslation();
  return (
    <>
      <section id="socialFeeds" className={classes.section}>
        {/* <img src={SMFeedsBg} alt="" className="SM-Bg" /> */}
        <Container fixed>
          <div className="section-title" style={{ marginBottom: '16px' }}>
            <h2>{t('sections-SMFeeds-SMFeeds-Head')}</h2>
            <p>{t('sections-SMFeeds-SMFeeds-para')}</p>
          </div>
        </Container>

        <div className={`smFeeds ${classes.row}`}>
          <Grid
            xs={12}
            md={3}
            sm={6}
            className=" shadow-col"
            id="twitterTimeline"
            style={{ marginTop: '16px' }}
          >
            <TwitterTimelineEmbed
              sourceType="profile"
              screenName="atulguptagst"
              options={{ height: 400 }}
            />
          </Grid>

          {/* <div
            className="col-11 col-sm-6 col-md-3 mt-3 shadow-col ml-sm-5"
            id="facebookTimeline"
          ></div> */}
        </div>
      </section>
    </>
  );
}

export default SMFeeds;
